import { render, staticRenderFns } from "./violationPage.vue?vue&type=template&id=71e6c269"
import script from "./violationPage.vue?vue&type=script&lang=js"
export * from "./violationPage.vue?vue&type=script&lang=js"
import style0 from "./violationPage.vue?vue&type=style&index=0&id=71e6c269&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports